module.exports = __webpack_public_path__ + "static/media/jeel-songs.e3cb09cb.png";